<template>
  <div class="error-page">
    <div class="gradient-panel">
      <div class="content-area">
        <div class="callout">
          <h4 class="error-title" id="errorTitle">
            <i class="material-icons warning">warning</i> {{ errorTitle }}
          </h4>
          <div class="divider"></div>
          <div class="error-body">
            <div class="semibold description" id="errorDescription">{{ errorDescription }}</div>
            <div> {{ errorDetails }} </div>
          </div>
          <div class="text-center">
            <button v-if="retryAllowed"
              :name="errorButtonAnalyticsName"
              @click="retry"
              class="button secondary expanded-for-small-only general-margin">
              {{ errorButtonText }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Strings
import strings from '@/i18n/en/strings';

// Utilities
import _ from 'lodash';

// Constants
import constants from '@/i18n/en/constants';

// Services
import AnalyticsService from '@/services/AnalyticsService';

export default {
  name: 'error-page',
  created() {
    window.scrollTo(0, 0);
    if (!this.errorType) {
      this.redirectToPage('find-your-bill');
    }
  },
  data() {
    return {
      analyticsConstants: constants.analyticsConstants,
      errorPage: strings.errorPage,
      errorType: this.$store.state.error
    }
  },
  mounted() {
    if (this.errorType === 'unknownFailure' ||
        this.errorType === 'knownPaymentError' ||
        this.errorType === 'tcErrorDecline' ||
        this.errorType === 'tcErrorCvv' ||
        this.errorType === 'tcErrorCall' ||
        this.errorType === 'tcErrorCarderror' ||
        this.errorType === 'tcErrorDuplicate') {
      AnalyticsService.trackPageView(this.analyticsConstants.FAILED_PAYMENT);
    }
  },
  computed: {
    retryAllowed() {
      // Compute whether the retry button should be shown based on the type of error that occurred.
      if (this.errorType === 'generalError' ||
          this.errorType === 'knownPaymentError' ||
          this.errorType === 'tcErrorDecline' ||
          this.errorType === 'tcErrorCvv' ||
          this.errorType === 'tcErrorCall' ||
          this.errorType === 'tcErrorCarderror' ||
          this.errorType === 'tcErrorDuplicate') {
        return true;
      } else {
        return false;
      }
    },
    errorTitle() {
      return _.get(this.errorPage, [this.errorType, 'title'], '');
    },
    errorDescription() {
      return _.get(this.errorPage, [this.errorType, 'description'], '');
    },
    errorDetails() {
      return _.get(this.errorPage, [this.errorType, 'details'], '');
    },
    errorButtonText() {
      return _.get(this.errorPage, [this.errorType, 'buttonText'], '');
    },
    errorButtonAnalyticsName() {
      const editPaymentInfoErrorTypes = [
        'tcErrorDecline',
        'tcErrorCvv',
        'tcErrorCall',
        'tcErrorCarderror',
        'tcErrorDuplicate'
      ];
      if (editPaymentInfoErrorTypes.indexOf(this.errorType) > -1) {
        return this.analyticsConstants.errorPage.EDIT_PAYMENT_INFO;
      }
      return '';
    }
  },
  methods: {
    retry() {
      if (this.errorType === 'generalError') {
        this.goToPage('find-your-bill');
      } else if (this.errorType === 'knownPaymentError' || this.errorType === 'tcErrorDecline' ||
        this.errorType === 'tcErrorCvv' || this.errorType === 'tcErrorCall' ||
        this.errorType === 'tcErrorCarderror' || this.errorType === 'tcErrorDuplicate') {
        this.$store.dispatch('CREATE_PAYMENT_RESOURCE')
        .then(() => {
          this.goToPage('payment-info');
        })
        .catch(() => {
          this.goToPage('error');
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~@/styles/variables.scss';

.error-page {
  .gradient-panel {
    // Gradient bar needs to be shown on top and bottom of error page
    border-image-slice: 1 1 1;

    .content-area {
      margin-top: 45px;
      margin-bottom: 40px;

      .callout {
        border: 2px solid $alert-color;

        .error-title {
          color: $alert-color;
          text-align: center;
          font-weight: normal;

          .warning {
            transform: translateY(15%);
          }
        }

        .general-margin {
          margin-top: 30px;
        }

        .divider {
          width: 100%;
          height: 1px;
          background-color: $medium-gray;
          margin: 20px 0;
        }

        .error-body {
          font-weight: normal;

          .semibold {
            font-weight: $global-weight-semibold;
          }

          .description {
            margin-bottom: 8px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ErrorPage.vue